import React from 'react';

export const BRAND_LOGO_URL = 'https://storage.googleapis.com/question-mark-pizza-point/logo/logo.png';

export function BrandLogo({ className = '', alt = 'Question Mark Pizza Point' }) {
  return (
    <img
      src={BRAND_LOGO_URL}
      alt={alt}
      className={['brand-mark', className].filter(Boolean).join(' ')}
      width={40}
      height={40}
      decoding="async"
    />
  );
}
